import React from 'react';
import { AppProps } from '../../types';
import { getShareComponentProps } from '../ShareEvent/ShareEventRoot';
import { dynaMount } from '../utils/mountComponent';
import CollectionsLink, {
    CollectionsLinkComponentProps,
} from './CollectionsLink';
import { CREATOR_COLLECTIONS_FORMATTED_RESPONSE } from './__mocks__/creatorCollectionsFormattedResponse';

const HERO_LINK_TO_CREATOR_COLLECTIONS_ID =
    'listings-root__link-to-creator-collections';

const getCollectionsLinkProps = (
    props: AppProps,
): CollectionsLinkComponentProps => {
    const shareComponentProps = getShareComponentProps(props);
    // TODO: Replace collections props with real data
    return {
        collectionName: 'Health & Wellness',
        collectionUrl: '/cc/1234',
        collections: CREATOR_COLLECTIONS_FORMATTED_RESPONSE,
        collectionsQuantity: 10,
        shareComponentProps,
    };
};

const CollectionsLinkMount = (props: CollectionsLinkComponentProps) =>
    dynaMount(
        {
            Component: CollectionsLink,
            containerId: HERO_LINK_TO_CREATOR_COLLECTIONS_ID,
        },
        props,
    );

const CollectionsLinkRoot = (props: AppProps): JSX.Element | null => {
    const collectionsLinkProps = getCollectionsLinkProps(props);

    return <CollectionsLinkMount {...collectionsLinkProps} />;
};

export default CollectionsLinkRoot;
